import { useTranslation as useI18nextTranslation } from 'react-i18next'

/**
 * Custom hook for translations in auth pages
 * Automatically uses 'auth' namespace
 */
export function useAuthTranslation() {
  return useI18nextTranslation('auth')
}

/**
 * Custom hook for common translations
 * Uses 'common' namespace
 */
export function useCommonTranslation() {
  return useI18nextTranslation('common')
}

/**
 * Re-export the original useTranslation for flexibility
 */
export { useI18nextTranslation as useTranslation }
